import { render, staticRenderFns } from "./ElderlyDataStatistics.vue?vue&type=template&id=88dad56c&"
import script from "./ElderlyDataStatistics.vue?vue&type=script&lang=js&"
export * from "./ElderlyDataStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports